export const sanitizeText = (value) =>
  String(value ?? "").replace(/[^a-zA-Z0-9 .,-]/g, "");
export const sanitizeNumber = (value) =>
  String(value ?? "").replace(/[^0-9]/g, "");
export const sanitizeEmail = (value) =>
  String(value ?? "").replace(/[^\w@.+-]/g, "");
export const sanitizePhone = (value) =>
  String(value ?? "").replace(/[^0-9]/g, "");
export const sanitizePostcode = (value) =>
  String(value ?? "")
    .toUpperCase()
    .replace(/[^A-Z0-9 ]/g, "")
    .replace(/\s+/g, " ");
